import { Box, Text } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const VideoTag = styled(Box)`
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  border-radius: ${({ theme }) => theme.border_radius.card};
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey_5};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  max-width: 350px;
`

export const VideoText = styled(Text)`
  overflow: hidden;
  p {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
